import { render } from "./FamilyRow.vue?vue&type=template&id=84498182"
import script from "./FamilyRow.vue?vue&type=script&lang=js"
export * from "./FamilyRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Assessments/FamilyRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84498182"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84498182', __exports__)) {
    console.log('reload')
    api.reload('84498182', __exports__)
  }
  
  module.hot.accept("./FamilyRow.vue?vue&type=template&id=84498182", () => {
    console.log('re-render')
    api.rerender('84498182', render)
  })

}


export default __exports__